import React, { Component } from 'react';
import { EmojiVo } from '../classes/dataObjects/EmojiVo';
interface MyProps {callback:Function }
interface MyState {selectedEmoji: EmojiVo[],filterText: string}
class EmojiPanel extends Component<MyProps, MyState> {
    private emojis: EmojiVo[] = [];
        constructor(props: MyProps) {
            super(props);
            this.state = { selectedEmoji: [] , filterText: '' };
        }
    componentDidMount() {
        this.loadEmoji();
    }
    loadEmoji() {
        fetch('emojis.json')
            .then(response => response.json())
            .then(data => {
              //  console.log(data);
                // Process the emoji data as needed
                for(const key in data) {
                   let emojiArray = data[key];
                   console.log(key, emojiArray);
                   if (emojiArray.length < 4) {
                       continue;
                   }
                   let emojiVo = new EmojiVo(emojiArray[0], emojiArray[1], emojiArray[2], emojiArray[3]);
                   console.log(emojiVo);
                   this.emojis.push(emojiVo);
                }
             //   this.setState({ selectedEmoji: this.emojis });
                this.defaultEmoji();
            })
            .catch(error => {
                console.error('Error fetching emojis:', error);
            });
      

    }
    getEmojiList() {
        let emojiList: JSX.Element[] = [];
        for (let i = 0; i < this.state.selectedEmoji.length; i++) {
            let emojiKey = "emojiKey" + i;
            //use unicode for emoji
            emojiList.push(<div key={emojiKey} className='emoji' onClick={() => { this.props.callback(this.state.selectedEmoji[i].image) }}>
               {this.state.selectedEmoji[i].image}
            </div>);
        }
        return (<div className='emojiGrid'>{emojiList}</div>);
    }
    defaultEmoji() {
        console.log(this.emojis);
        //filter emojis to only those that contain the word face, smile, or heart
        let allEmojis: EmojiVo[] =[];
        let filteredEmojis: EmojiVo[] = this.emojis.filter((emoji) => emoji.description.includes('happy'));
        console.log("filteredEmojis", filteredEmojis);
        allEmojis.push(...filteredEmojis);
         filteredEmojis = this.emojis.filter((emoji) => emoji.description.includes('smile'));
        allEmojis.push(...filteredEmojis);
        filteredEmojis = this.emojis.filter((emoji) => emoji.description.includes('heart'));
        allEmojis.push(...filteredEmojis);
        filteredEmojis = this.emojis.filter((emoji) => emoji.description.includes('face'));
        allEmojis.push(...filteredEmojis); 
        //limit to 50 emojis
        if (allEmojis.length > 100) {
            allEmojis = allEmojis.slice(0, 100);
        }
        this.setState({ selectedEmoji: allEmojis });

    }
    filterEmoji() {
        if (this.state.filterText.length === 0) {
            this.defaultEmoji();
            return;
        }



        let filteredEmojis: EmojiVo[] = this.emojis.filter((emoji) => emoji.description.includes(this.state.filterText));
        //limit to 50 emojis
        if (filteredEmojis.length > 50) {
            filteredEmojis = filteredEmojis.slice(0, 50);
        }
        this.setState({ selectedEmoji: filteredEmojis });
    }
    onFilterTextChange(e: React.ChangeEvent<HTMLInputElement>) {
        this.setState({ filterText: e.target.value }, () => {
            this.filterEmoji();
        }
    );
    }
    render() {
        return (<div id="emojiPanel">
            <input type="text" value={this.state.filterText} onChange={(e) => this.onFilterTextChange(e)} placeholder="Filter emojis" />            
            {this.getEmojiList()}</div>);
    }
}
export default EmojiPanel;